import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { VnskySupportOcsInfoInjection } from "features/vnskySupportOcsInfo/di/VnskySupportOcsInfoInjection";
import { injectable } from "tsyringe";
import { VnSkyOscLookupRequestEntity } from "../entities/VnSkyOscLookupRequestEntity";
import { VnSkyOscLookupResponseEntity } from "../entities/VnSkyOscLookupResponseEntity";
import { IVnSkyOscLookupRepository } from "../repositories/IVnSkyOscLookupRepository";

@injectable()
export class VnSkyOscLookupUseCase {
  private oscLookupRepo: IVnSkyOscLookupRepository;

  constructor() {
    this.oscLookupRepo = VnskySupportOcsInfoInjection.getRepo();
  }
  async lookupOsc(
    params: VnSkyOscLookupRequestEntity,
  ): Promise<BaseApiResponseModel<VnSkyOscLookupResponseEntity>> {
    return await this.oscLookupRepo.lookupOsc(params);
  }
}
